import { NgModule } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import { CommonModule } from '../common/common.module';
import { MainComponent } from './components/main/main.component';
import { HttpClientModule } from '@angular/common/http';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { SearchComponent } from '@app/search/components/search/search.component';
import { SearchResultComponent } from '@app/search/components/search-result/search-result.component';
import {SearchFilterItemComponent} from "@app/search/components/search-filter-item/search-filter-item.component";
import {SearchSuggestionsComponent} from "@app/search/components/search-suggestions/search-suggestions.component";
import {SearchResultNamePipe} from "@app/search/components/pipes/search-result-name.pipe";
import { SearchResultSubjectNamePipe } from "@app/search/components/pipes/search-result-subject-name.pipe";
import { SearchResultSubjectBirthYearPipe } from "@app/search/components/pipes/search-result-subject-birth-year.pipe";
import { SearchHighlightDirective } from "@app/search/components/directives/search-highlight.directive";

registerLocaleData(localeCs, 'cs');

export const searchState: Ng2StateDeclaration = {
  name: 'search',
  url: '/search',
  abstract: true,
  component: MainComponent
};


export const fullState: Ng2StateDeclaration = {
  name: 'search.full',
  url: '/full',
  data: {
    title: 'Vyhledávání',
  },
  views: {
    'content@search': {
      component: SearchComponent,
    }
  },
};

@NgModule({
  imports: [
    CommonModule,
    UIRouterModule.forChild({
      states: [
        searchState,
        fullState
      ]
    }),
    HttpClientModule,
  ],
  providers: [
    DatePipe,
  ],
  declarations: [
    MainComponent,
    SearchComponent,
    SearchResultComponent,
    SearchFilterItemComponent,
    SearchSuggestionsComponent,
    SearchResultNamePipe,
    SearchResultSubjectNamePipe,
    SearchResultSubjectBirthYearPipe,
    SearchHighlightDirective
  ],
})
export class SearchAppModule {
}
